<template>
  <v-layout column align-start class="view-field">
    <v-layout row align-center class="title-section">
      <v-icon
        class="view-field-icon"
        color="accent"
        left
        size="18"
        style="margin-right: 15px;"
      >
        {{ icon }}
      </v-icon>
      {{ label }}
    </v-layout>

    <div class="data" v-if="data === null || data === undefined">
      -
    </div>

    <div
      class="data"
      v-else-if="typeof data === 'number' || typeof data === 'string'"
    >
      {{ data }}
    </div>

    <div class="data" v-else v-for="item in data" :key="item">
      {{ item }}
    </div>

    <app-no-permission-warning
      v-if="!hasPermission"
      style="padding: 0 0 0 35px"
    />
  </v-layout>
</template>

<script>
import AppNoPermissionWarning from "@/components/_Molecules/AppNoPermissionWarning";

export default {
  name: "ViewPageDataField",

  components: { AppNoPermissionWarning },

  props: {
    /**
     * Label of the field.
     */
    label: {
      type: String
    },
    /**
     * Data/content of the field.
     */
    data: {
      type: [String, Number, Array]
    },
    /**
     * Source of the field icon.
     */
    icon: {},

    hasPermission: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    shownData() {
      if (this.data) {
        return this.data;
      }
      return "-";
    }
  }
};
</script>

<style scoped>
.view-field {
  word-break: break-word;
  text-overflow: ellipsis;
  margin-bottom: 20px;
  font-size: 12px;
}
.view-field .title-section {
  color: #808080;
  text-align: left;
}
.view-field .title-section .view-field-icon {
  color: var(--v-accent-base) !important;
}
.view-field .title-section .icon {
  height: 14px;
  width: 14px;
  margin-right: 5px;
}
.view-field .title-section .icon path {
  fill: var(--primary-highlight);
}
.view-field .data {
  text-align: left;
  font-weight: 700;
  padding-left: 35px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/ViewPage/ViewPageDataField.vue